import { styled } from '@mui/system'

export const Root = styled('div')`
	width: 100%;
	position: fixed;
	left: 0;
	top: 0;
	z-index: 12;
`
